// extracted by mini-css-extract-plugin
export default {"productAll":"ProductsAll_productAll__-RXw+"};